/* global Chartist */
(function (window, document, Chartist) {
  
  
  const defaultOptions = {
    value: null,
    averageLineClass: 'ct-line-average',
    averageLineStyle: {
      stroke: '#000000',
      'stroke-width': 2,
      'stroke-dasharray': '4,2',
    },
    averageTextStyle: {
      'font-size': '12px',
      fill: '#000000',
    },
  };
  
  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.ctAverageLine = function (options) {
    options = Chartist.extend({}, defaultOptions, options);
  
    return function ctAverageLine(chart) {
  
      if (!(chart instanceof Chartist.Line || chart instanceof Chartist.Bar)) {
        return;
      }
  
      chart.on('created', (data) => {
        if (!options.value || !data.bounds || !data.chartRect) {
          return;
        }
  
        const { chartRect, bounds, svg } = data;
        const chartHeight = chartRect.y1 - chartRect.y2;
  
        const yavg = chartRect.y1
            - ((options.value - bounds.low) / (bounds.high - bounds.low))
            * chartHeight;

        const range = bounds.high - bounds.low;
        const relativeValue = range !== 0 ? (options.value - bounds.low) / range : 0;
        const yavg2 = chartRect.y1 - (relativeValue * chartHeight);
  
        const lineAttributes = {
          x1: chartRect.x1,
          y1: yavg,
          x2: chartRect.x2,
          y2: yavg,
          ...options.averageLineStyle,
        };
  
        svg.elem('line', lineAttributes, options.averageLineClass);
  
        svg.elem('text', {
          x: chartRect.x2 - 10,
          y: yavg - 5,
          style: 'text-anchor: end',
          ...options.averageTextStyle,
        }, options.averageLineClass).text(`Média: ${options.value.toFixed(2)}`);
      });
    };
  };
}(window, document, Chartist));
